const state = {
    isAvailable: false,
    isUpdating: false,
    serviceWorkerRegistration: null,
}

const getters = {}

const mutations = {
    setAvailable(state, payload) {
        state.isAvailable = !!payload
    },

    setUpdating(state, payload) {
        state.isUpdating = !!payload
    },

    setServiceWorkerRegistration(state, payload) {
        state.serviceWorkerRegistration = payload
    },
}

const actions = {
    setServiceWorkerRegistration({ commit }, payload) {
        commit('setServiceWorkerRegistration', payload)
        commit('setAvailable', true)
    },

    update() {
        if (!state.serviceWorkerRegistration || !state.serviceWorkerRegistration.waiting) {
            return
        }

        state.serviceWorkerRegistration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
